import { useNavigate } from 'react-router-dom'
import ROUTES from '@client-hub/shared/constants/routes'
import MfaEnable from 'components/Mfa/Enable'

const MfaEdit = () => {
  const navigate = useNavigate()
  const onSuccess = (state: Record<string, unknown>) => navigate(ROUTES.MFA.EDIT.CODE, { state })

  return <MfaEnable onSuccess={onSuccess} />
}

export default MfaEdit
